import { ENTITY_TYPE, EntityType, MembershipMode } from '../../models/entity.model';
import { isScimManagedGroupId } from '../../models/group.model';
import { FgaIconName, GROUP_ICON } from '../fga-icon/fga-icon.model';

export type SortKey = 'name';

export type SortDir = 'asc' | 'desc';

export type TabKey = MembershipMode;

export type TableMode = MembershipMode;

export interface TableRow {
  id: string;
  name: string;
  email?: string;
  type: EntityType;
}

export interface TableRowIcon {
  name: FgaIconName;
  ariaLabel: string;
}

export const TABLE_ROW_ICON = {
  USER: { name: ENTITY_TYPE.USER, ariaLabel: 'User' },
  LOCAL_GROUP: { name: GROUP_ICON.LOCAL, ariaLabel: 'Group managed here' },
  SCIM_GROUP: { name: GROUP_ICON.SCIM, ariaLabel: 'Group managed by your Organisation' },
  M2M: { name: ENTITY_TYPE.M2M, ariaLabel: 'Machine-to-machine client' },
} as const satisfies Record<string, TableRowIcon>;

export const TABLE_ROW_TYPE_LABEL = {
  LOCAL_GROUP: 'Application group',
  M2M: 'Service',
  SCIM_GROUP: 'Enterprise-managed group',
  USER: 'User',
} as const;

export function resolveTableRowTypeLabel(row: TableRow): string {
  switch (row.type) {
    case ENTITY_TYPE.GROUP:
      return isScimManagedGroupId(row.id)
        ? TABLE_ROW_TYPE_LABEL.SCIM_GROUP
        : TABLE_ROW_TYPE_LABEL.LOCAL_GROUP;
    case ENTITY_TYPE.M2M:
      return TABLE_ROW_TYPE_LABEL.M2M;
    case ENTITY_TYPE.USER:
    default:
      return TABLE_ROW_TYPE_LABEL.USER;
  }
}
